import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import GrowlyyLogo from '../common/GrowlyyLogo';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-md fixed w-full z-50">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center">
          <GrowlyyLogo size="small" />
        </div>

        {/* Navigation pour desktop */}
        <nav className="hidden md:flex space-x-8">
          <a href="#accueil" className="text-growlyy-gray-dark hover:text-growlyy-primary transition duration-300">Accueil</a>
          <a href="#fonctionnalites" className="text-growlyy-gray-dark hover:text-growlyy-primary transition duration-300">Fonctionnalités</a>
          <a href="#temoignages" className="text-growlyy-gray-dark hover:text-growlyy-primary transition duration-300">Témoignages</a>
          <a href="#tarifs" className="text-growlyy-gray-dark hover:text-growlyy-primary transition duration-300">Tarifs</a>
          <a href="#faq" className="text-growlyy-gray-dark hover:text-growlyy-primary transition duration-300">FAQ</a>
        </nav>

        {/* Boutons CTA */}
        <div className="hidden md:flex space-x-4">
          <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="btn-secondary">
            Réserver une démo
          </a>
          <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="btn-primary btn-pulse">
            Commencer
          </a>
        </div>

        {/* Menu burger pour mobile */}
        <div className="md:hidden">
          <button onClick={toggleMenu} className="text-growlyy-primary focus:outline-none">
            {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>

      {/* Menu mobile */}
      {isMenuOpen && (
        <div className="md:hidden bg-white py-4 px-4 shadow-lg z-50">
          <nav className="flex flex-col space-y-4">
            <a href="#accueil" className="text-growlyy-gray-dark hover:text-growlyy-primary transition duration-300">Accueil</a>
            <a href="#fonctionnalites" className="text-growlyy-gray-dark hover:text-growlyy-primary transition duration-300">Fonctionnalités</a>
            <a href="#temoignages" className="text-growlyy-gray-dark hover:text-growlyy-primary transition duration-300">Témoignages</a>
            <a href="#tarifs" className="text-growlyy-gray-dark hover:text-growlyy-primary transition duration-300">Tarifs</a>
            <a href="#faq" className="text-growlyy-gray-dark hover:text-growlyy-primary transition duration-300">FAQ</a>
            <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="btn-secondary w-full mb-2">
              Réserver une démo
            </a>
            <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="btn-primary w-full">
              Commencer
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header; 